import { FontWeight } from '@y42/json-schema';
import * as go from 'gojs';
import { GojsShadow } from '../../../models/gojs-shadow.model';
import { gojsDataToBorderStyleModel } from '../../../utils/border-style-utils';
import { gojsDataToFontModel } from '../../../utils/font-utils';
import { gojsDataToShadowModel } from '../../../utils/shadow-utils';
import {
  BACKGROUND_COLOR_PROP,
  BORDER_COLOR_PROP,
  BORDER_STYLE_PROP,
  BORDER_WIDTH_PROP,
  LAYER_NAME_PROP,
  LOCKED_PROP,
  SHADOW_BLUR_PROP,
  SHADOW_COLOR_PROP,
  SHADOW_OFFSET_PROP,
  TEXT_ALIGNMENT_PROP,
  TEXT_COLOR_PROP,
  TEXT_FONT_PROP,
  TEXT_HIGHLIGHT_COLOR_PROP,
  TEXT_PROP,
  Z_ORDER_PROP,
} from '../config/common-prop-names';

export const getLockedState = (data: go.ObjectData): boolean => data[LOCKED_PROP];

export const getShadowData = (data: go.ObjectData): GojsShadow =>
  gojsDataToShadowModel(data, SHADOW_BLUR_PROP, SHADOW_COLOR_PROP, SHADOW_OFFSET_PROP);

export const getBackgroundColor = (data: go.ObjectData) => data[BACKGROUND_COLOR_PROP];

export const getFontFamily = (data: go.ObjectData): string => gojsDataToFontModel(data, TEXT_FONT_PROP).fontFamily;

export const getFontSize = (data: go.ObjectData): number => gojsDataToFontModel(data, TEXT_FONT_PROP).fontSize;

export const getFontWeight = (data: go.ObjectData): FontWeight => gojsDataToFontModel(data, TEXT_FONT_PROP).fontWeight;

export const getText = (data: go.ObjectData): string => data[TEXT_PROP];

export const getTextColor = (data: go.ObjectData): string => data[TEXT_COLOR_PROP];

export const getLayerName = (data: go.ObjectData): string => data[LAYER_NAME_PROP];

export const getZOrder = (data: go.ObjectData): string => data[Z_ORDER_PROP];

export const getTextAlignment = (data: go.ObjectData) => data[TEXT_ALIGNMENT_PROP];

export const getBorderColor = (data: go.ObjectData) => data[BORDER_COLOR_PROP];

export const getTextHighlightColor = (data: go.ObjectData) => data[TEXT_HIGHLIGHT_COLOR_PROP];

export const getBorderStyleData = (data: go.ObjectData) =>
  gojsDataToBorderStyleModel(data, BORDER_WIDTH_PROP, BORDER_STYLE_PROP);
